export const REGULAR = "Sans-serif";
export const BOLD = "Sans-serif";
export const LIGHT = "Sans-serif";

export const OS_REGULAR = "OpenSans-Regular";
export const OS_BOLD = "OpenSans-Bold";
